<template>
  <div class="page-hero">
    <div class="page-hero__media">
      <img :src="getImage" alt="Alt description for the image">
    </div>
    <div v-if="transparent" class="page-hero__transparent"></div>
    <div v-else class="page-hero__gradient"></div>
    <BaseContainer>
      <div class="page-hero__ratio"></div>
    </BaseContainer>
    <div class="absolute inset-0 flex items-center">
      <BaseContainer class="w-full">
        <div class="max-w-2xl">
          <slot></slot>
        </div>
      </BaseContainer>
    </div>
  </div>
</template>

<script>
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'PageHero',
  components: { BaseContainer },
  props: {
    transparent: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: 'ar-hero.jpg'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.page-hero {
  @apply w-full text-white relative bg-body-dark py-20;
}
.page-hero__media > img {
  @apply w-full h-full mx-auto;
  max-width: 1600px;
  object-fit: cover;
}
.page-hero__media {
  @apply inset-0 absolute w-full h-full;
}
.page-hero__ratio {
  @apply aspect-ratio-19/9 w-full overflow-hidden;
}
.page-hero__transparent {
  @apply inset-0 absolute w-full h-full bg-transparent;
}
.page-hero__gradient {
  @apply inset-0 absolute w-full h-full bg-gradient-br-dark;
}
@screen md {
  .page-hero {
    @apply py-8;
  }
}
@screen lg {
  .page-hero {
    @apply py-0;
  }
}
</style>
